import Service from "../../AuthService";
const ShoppingEmployee = {
    getShoppingEmployee(page) {
        return Service.get("/shopping_employee?page="+page);
    },
    showShoppingEmployee(id) {
        return Service.get("/shopping_employee/" + id);
    },
    updateShoppingEmployee(id, data) {
        return Service.put("/shopping_employee/" + id, data);
    },
    createShoppingEmployee(id,data) {
        return Service.post("/shopping_employee", id, data);
    },
    deleteShoppingEmployee(id) {
        return Service.delete("/shopping_employee/" + id);
    },
    searchShoppingEmployee(data){
        return Service.post('/shopping_employee_search',data);
    },
};
export default ShoppingEmployee;
